import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarControlFn = /* @__PURE__ */ createRecipe('calendar-control', {}, [])

const calendarControlVariantMap = {}

const calendarControlVariantKeys = Object.keys(calendarControlVariantMap)

export const calendarControl = /* @__PURE__ */ Object.assign(memo(calendarControlFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarControl',
  __getCompoundVariantCss__: calendarControlFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarControlVariantKeys,
  variantMap: calendarControlVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarControlVariantKeys)
  },
  getVariantProps: calendarControlFn.getVariantProps,
})